import React from 'react';

import Header from '../partials/Header'; 

// Las secciones suben un nivel a components/ y entran directo a content/
import Hero from '../content/Hero/Hero';
import Services from '../content/Services/Services';
import Trust from '../content/Trust/Trust';
import Contact from '../content/Contact/Contact';

export const EmpresasScreen = () => {
  return (
    <>
      <Header /> 
      <main>
        <Hero />
        <Services />
        <Trust />
        <Contact />
      </main>
    </>
  );
};